<div class="wrapper">
  <!-- top navbar-->
  <app-header class="topnavbar-wrapper"></app-header>
  <!-- sidebar-->
  <app-sidebar [class]="validateToggle()"> </app-sidebar>
  <!-- Offsidebar -->

  <div
    class="offsidebar-report"
    [class.open]="
      (isOffsidebarOpen && report_selected) || (isOffsidebarOpen && sector)
    "
  >
    <div
      class="offsidebar-toggle-button-open"
      (click)="toggleOffsidebar()"
      *ngIf="!isOffsidebarOpen"
    >
      <i class="fas fa-map-marker"></i>
    </div>
    <!-- Aquí puedes incluir contenido dinámico, configuraciones, etc -->
    <div class="position-relative">
      <ng-container *ngIf="report_selected || sector">
        <div
          class="offsidebar-toggle-button-close animated fadeIn"
          (click)="toggleOffsidebar()"
          *ngIf="isOffsidebarOpen"
        >
          <i class="fas fa-minus"></i>
        </div>
      </ng-container>
      <ng-container *ngIf="isOffsidebarOpen && report_selected">
        <div class="bg-primary p-3 text-white">
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="m-0">{{ report_selected.title | titlecase }}</h4>
            <i
              class="fa fa-times text-danger c-pointer"
              (click)="toggleOffsidebar(true)"
            ></i>
          </div>
          <p class="m-0">
            {{
              report_selected.datetime
                | date : "'El' EEEE, MMMM d, y 'a las ' h:mm a "
            }}

            <em
              class="fa fa-comment"
              [ngbTooltip]="
                report_selected.observation === ''
                  ? 'Sin redactar'
                  : report_selected.observation
              "
            ></em>
          </p>

          <button
            class="btn black-btn center"
            style="font-size: 12px"
            (click)="goRequisitions()"
          >
            Requisición o diagnostico
            <i class="fa fa-file-text" aria-hidden="true"></i>
          </button>
        </div>

        <app-report></app-report>
        <!-- contenido -->
      </ng-container>
    </div>

    <div *ngIf="sector">
      <div class="bg-primary p-3 text-white">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex flex-column">
            <h4 class="m-0">Hacer reporte instantaneo</h4>
            <small>Crea reportes sin necesidad de un recorrido</small>
          </div>
          <i
            class="fa fa-times text-danger c-pointer"
            (click)="toggleOffsidebar(true)"
          ></i>
        </div>
      </div>
      <app-individual-report-form></app-individual-report-form>
    </div>
    <!-- contenido -->
  </div>

  <!-- Main section-->
  <section [class]="validateToggleContent()">
    <div
      class="h-100"
      [ngClass]="{
        'm-sm-4 m-md-5 mt-0 mt-md-4': margin
      }"
    >
      <router-outlet></router-outlet>
    </div>
  </section>
  <!-- Page footer-->
  <!--     <footer class="footer-container" app-footer></footer> -->
</div>
